import { Check } from 'lucide-react';
import { WIZARD_STEPS, StepIndex } from './types';

interface StepIndicatorProps {
  currentStep: StepIndex;
}

export function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-between mb-2">
      {WIZARD_STEPS.map((label, idx) => {
        const stepNum = (idx + 1) as StepIndex;
        const isDone = stepNum < currentStep;
        const isCurrent = stepNum === currentStep;
        return (
          <div key={label} className="flex items-center flex-1">
            <div className="flex items-center gap-2">
              <div
                className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold ${
                  isDone
                    ? 'bg-green-600 text-white'
                    : isCurrent
                    ? 'bg-blue-600 text-white'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {isDone ? <Check className="h-4 w-4" /> : stepNum}
              </div>
              <span
                className={`text-xs font-medium ${
                  isCurrent ? 'text-blue-600' : isDone ? 'text-green-700' : 'text-muted-foreground'
                }`}
              >
                {label}
              </span>
            </div>
            {idx < WIZARD_STEPS.length - 1 && (
              <div
                className={`h-px flex-1 mx-3 ${isDone ? 'bg-green-600' : 'bg-border'}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
